export let state = {
  user: { token: {}, info: {} },
  loading: false,
  error: "",
};

export default state;
